import * as React from 'react';
import * as styles from './DesignSettingsPanel.css';
import * as adminStyles from '../AdminStyles.css';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../stores';
import MenuBarSettings from './pivots/MenuBarSettings';
import TopItemsSettings from './pivots/TopItemsSettings';
import ElementGroupsSettings from './pivots/ElementGroupsSettings';
import ElementsSettings from './pivots/ElementsSettings';
import { IAPivot } from '../../../pivot/Pivot';
import { IAIcon } from '../../../icon/Icon';
import { LocalizationService } from '../../../../services/LocalizationService';
import { Helper } from '../../../../Helper';

export interface IDesignSettingsPanelProps {
  navigatorStore?: NavigatorStore;
}

export interface IDesignSettingsPanelState {
  selectedPivot: string;
}

@inject('navigatorStore')
@observer
export default class DesignSettingsPanel extends React.Component<IDesignSettingsPanelProps, IDesignSettingsPanelState> {

  private readonly localizationService = new LocalizationService();
  
  constructor(props: IDesignSettingsPanelProps) {
    super(props);
    this.state = {
      selectedPivot: "Menu bar"
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    let pivotContentPosition: number = 0;
    switch (this.state.selectedPivot) {
      case "Menu bar":
        pivotContentPosition = 30;
        break;
      case "Top items":
        pivotContentPosition = -370;
        break;
      case "Element groups":
        pivotContentPosition = -770;
        break;
      case "Elements":
        pivotContentPosition = -1170;
        break;
    }
    let top = 51;
    switch (Helper.getDisplayEnvironment()) {
      case "ExternalEnvironment":
        top = 51;
        break;
      case "Sharepoint":
        top = 161;
        break;
    }
    return (
      <div
        className={adminStyles.panel}
        style={{
          right: this.props.navigatorStore.isShowingDesignSettings ? "0px" : "-400px",
          top: top,
          height: `calc(100% - ${top}px)`
        }}
      >
        <div className={adminStyles.panelHeader}>
          {this.localizationService.strings.Navigator_Design_DesignSettings}
          <IAIcon
            title={"Close"}
            size={20}
            color="#ffffff"
            onClick={() => this.props.navigatorStore.toggleDesignSettings()}
            style={{
              float: "right",
              padding: "5px 10px",
              cursor: "pointer"
            }}
          />
        </div>
        <div className={adminStyles.content}>
          <IAPivot
            highlightColor={this.props.navigatorStore.adminColor}
            items={[
              {
                key: "Menu bar",
                text: this.localizationService.strings.Navigator_Design_MenuBar
              },
              {
                key: "Top items",
                text: this.localizationService.strings.Navigator_Design_TopItems
              },
              {
                key: "Element groups",
                text: this.localizationService.strings.Navigator_Design_ElementGroups
              },
              {
                key: "Elements",
                text: this.localizationService.strings.Navigator_Design_Elements
              }
            ]}
            selectedKey={this.state.selectedPivot}
            select={(selectedPivot: string) => this.setState({ selectedPivot })}
          />
          <div
            className={styles.pivotContent}
            style={{ left: pivotContentPosition }}
          >
            <MenuBarSettings />
            <TopItemsSettings />
            <ElementGroupsSettings />
            <ElementsSettings />
          </div>
        </div>
      </div>
    );
  }
}